/** Document metadata tag keys (stable string enum; copied from t-shared for P5 decoupling). */
export enum DocumentTagKey {
  VENDOR = 'Vendor',
  DRUG = 'Drug',
  AMENDMENT = 'Amendment',
  ICF_TYPE = 'ICF Type',
  STAFF = 'Staff',
  PRINCIPAL_INVESTIGATOR = 'Principal Investigator',
  LAB = 'Lab',
  LAB_PERSONNEL_NAME = 'Lab Personnel Name',
}
